<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <h1 class="page-title"> {{ user.firstName }} {{ user.lastName }}</h1>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <mine-user-edit v-if="!isLoading" :user="this.user" :user-id="Number(this.userId)" @userUpdated="userUpdated"></mine-user-edit>
            <mine-technician-edit v-if="!isLoading&&this.user.technician" :technician-id="Number(this.user.technician.id)" ></mine-technician-edit>
            <template v-if="!isLoading&&this.user.structures">
              <mine-structure-edit  v-for="structure in this.user.structures" v-if="structure" :structure-id="structure.id" :structure-name="structure.tostring" :key="structure.tostring+'-'+structure.id" @structureUpdated="structureUpdated"></mine-structure-edit>
            </template>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from '../../services/api'
import i18n from '../../i18n'
import MineUserEdit from "./profileEdit/MineUserEdit";
import MineTechnicianEdit from "./profileEdit/MineTechnicianEdit";
import MineStructureEdit from "./profileEdit/MineStructureEdit";

export default {

  name: 'Profile',

  components:{
    MineUserEdit,
    MineTechnicianEdit,
    MineStructureEdit
  },

  data () {
    return {
      userId: this.$store.getters.userId,
      user: {},
      isLoading:true,
      visibleObject: []
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    async fetchData () {
      this.fetchUser()
    },

    fetchUser () {
      this.isLoading=true
      api
        .get(`/user/getProfile`)
        .then(response => {
          this.user = response.data
          this.isLoading=false
        })
        .catch((error) => {
          this.$router.push({
            name: '/',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    userUpdated(user){
      this.isLoading=true
      this.user={...user,technician : this.user.technician,structures : this.user.structures}
      this.isLoading=false
    },
    structureUpdated(payload){
      const index = this.user.structures.findIndex(structure => structure.id === payload.id);
      if (index !== -1) {
        this.user.structures[index].tostring = payload.tostring;
      }
    }



  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/Profile.vue